import React from "react";
import { nl } from "./nl.jsx";

// Wspólne helpery nagłówków dla sekcji edytowalnych (model: before + wyróżnienie + after).
// Łamanie linii przez \n (Enter w textarea). Styl wyróżnienia jest zaszyty w markupie
// (a NIE w treści) — limit .hl.hl-paint ≤ 5 per podstrona wynika z kodu.

// Wyróżnienie brand-blue: <span class="hl hl-paint">.
export const HlHeading = ({ before = "", highlight = "", after = "" }) => (
  <>{nl(before)}{highlight ? <span className="hl hl-paint">{highlight}</span> : null}{nl(after)}</>
);

// Emfaza kursywą: <em>.
export const EmHeading = ({ before = "", em = "", after = "" }) => (
  <>{nl(before)}{em ? <em>{em}</em> : null}{nl(after)}</>
);
